@if (loader.isLoading$ | async) {
  <!-- aria-live so a screen reader hears that something is happening; the click that
       started it gave no other feedback. -->
  <div class="gl" role="status" aria-live="polite">
    <div class="gl__box">
      <span class="gl__spinner" aria-hidden="true"></span>
      <span class="gl__text">Working…</span>
    </div>
  </div>
}
